import axios from 'axios'
import Http from "./Http";

const aws = require('aws-sdk')

aws.config.update({
    secretAccessKey: process.env.VUE_APP_AWS_SECRET,
    accessKeyId: process.env.VUE_APP_AWS_KEY,
})
const aws_s3 = new aws.S3({
    signatureVersion: 'v4',
    region: process.env.VUE_APP_AWS_REGION
})


export default {

    async singleUpload(bucket, folder, fileName, file){

            //console.log(file.type)
            const key = folder + fileName
            const params = {
                Bucket: bucket,
                Key: key,
                //Expires: 10,
                ACL: 'public-read'
            }
            const url = aws_s3.getSignedUrl('putObject', params)
            return axios.put(url, file, {
                headers: {
                    'Content-Type': file.type,
                },
            })
          .then(result => {
                const bucketUrl = decodeURIComponent(result.request.responseURL).split(key )[0]
                result.key = key
                result.fullPath = bucketUrl + key
                return result
                
          })
          .catch(() => {
                return false
                // TODO: error handling
          })
    },

    async deleteObjectByKey(key) {
        const params = {
          Bucket: process.env.VUE_APP_AWS_S3_BUCKET,
          Key: key,
        }
        const data = aws_s3.deleteObject(params).promise()
      
        return data
    },

    async getInstances() {
        return await Http.get(`/aws/instances`)
    },
    async getInstanceDetails(InstanceId) {
        return await Http.get(`/aws/instances/${InstanceId}`)
    },
    async startInstance(InstanceId) {
        return await Http.patch(`/aws/instances/start/${InstanceId}`)
    },
    async stopInstance(InstanceId) {
        return await Http.patch(`/aws/instances/stop/${InstanceId}`)
    },
    async getLoadBalancers(data) {
        return await Http.get(`/aws/loadbalancers`, { params: data })
    },
    async getTargetGroups() {
        return await Http.get(`/aws/targetgroups`)
    },
    async getTargetGroupDetails(targetGroupArn) {
        return await Http.get(`/aws/targetgroup/details?TargetGroupArn=${targetGroupArn}`)
    },
    async getTargetGroupInstances(targetGroupArn) {
        return await Http.get(`/aws/targetgroup/instances?targetGroupArn=${targetGroupArn}`)
    },
    async registerInstanceToTargetGroup(data) {
        return await Http.patch(`/aws/targetgroup/instances/register`, data)
    },
    async deregisterInstanceToTargetGroup(data) {
        return await Http.patch(`/aws/targetgroup/instances/deregister`, data)
    },
    async getRDSInstances(data) {
        return await Http.get(`/aws/rds_instances`, { params: data })
    },
    async createReadDBInstance(data) {
        return await Http.post(`/aws/rds_instances/read_instance`, data)
    },
    async removeReadDBInstance(DBInstanceIdentifier) {
        return await Http.delete(`/aws/rds_instances/read_instance/${DBInstanceIdentifier}`)
    },
    async getApplications(data) {
        return await Http.get(`/aws/applications`, { params: data })
    },
    async getSecurityGroups(data) {
        return await Http.get(`/aws/security_groups`, { params: data })
    },
    async addSecurityGroupRule(data) {
        return await Http.post(`/aws/security_groups/addrule`, data)
    },
    async removeSecurityGroupRule(data) {
        return await Http.post(`/aws/security_groups/removerule`, data)
    },
    async targetGroupCharts(targetGroupArn, loadBalancerArn, DBClusterIdentifier, DBIdentifiers) {
        return await Http.get(`/aws/cloudwatch/targetGroupCharts?targetGroupArn=${targetGroupArn}&loadBalancerArn=${loadBalancerArn}&DBClusterIdentifier=${DBClusterIdentifier}&DBIdentifiers=${DBIdentifiers}`)
    },
    async updateInstance(InstanceId, data) {
        return await Http.patch(`/aws/instances/${InstanceId}`, data)
    },
    async getAutoScalingGroups() {
        return await Http.get(`/aws/autoscaling_groups`)
    },
    async editAutoScalingGroup(data) {
        return await Http.patch(`/aws/autoscaling_groups`, data)
    },
    async getScheduledActions(data) {
        return await Http.get(`/aws/scheduler?${data}`)
    },
    async addScheduledAction(data) {
        return await Http.post(`/aws/scheduler`, data)
    },
    async removeScheduledAction(id) {
        return await Http.delete(`/aws/scheduler/${id}`)
    },
    async getRDSClassTypes(data = '') {
        return await Http.get(`/aws/rds_instances/class_types?${data}`)
    },
    async editNote(data) {
        return await Http.patch(`/aws/notes`, data)
    },
    async getParameterStore(data){
        return await Http.get(`/aws/parameterstore`)
    },
    async editParameterStoreValue(data){
        return await Http.patch(`/aws/parameterstore`, data)
    },
    async addParameterStoreValue(data){
        return await Http.post(`/aws/parameterstore`, data)
    },
    async removeParameterValue(data){
        return await Http.delete(`/aws/parameterstore?${data}`)
    },
    async editInstanceTags(data){
        return await Http.patch(`/aws/tags`, data)
    },
    async addNewTemplateVersion(data){
        return await Http.post(`/aws/autoscaling_groups/template`, data)
    },
    async makeDefaultLaunchTemplate(data){
        return await Http.post(`/aws/autoscaling_groups/template/default`, data)
    },
    async getLaunchTemplateVersions(data){
        return await Http.get(`/aws/autoscaling_groups/template/versions?${data}`)
    },
    async removeLaunchTemplateVersion(data){
        return await Http.delete(`/aws/autoscaling_groups/template/versions`, { data: data })
    },
    async getRedisCharts() {
        return await Http.get(`/aws/cloudwatch/redischarts`)
    },
}



